











































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import LayoutModule from '../../store/layout';
import ConfigurationDrawer from '~/components/configuration/ConfigurationDrawer.vue';
import EnrollmentModule from '~/store/enrollment';
import DocumentUploadModule from '~/store/documentUpload';
@Component<Header>({
    components: {
        ConfigurationDrawer,
    },
})
export default class Header extends Vue {
    @Resolve
    public layout!: LayoutModule;

    @Resolve
    public enrollment!: EnrollmentModule;

    @Resolve
    public uploadModule!: DocumentUploadModule;

    public get headerLogoSrc() {
        if(this.$route.name ==='index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement' ) {
            return this.layout.configuration.images.header || this.$settings.url(this.$settings.headerLogo);
        }
        // if(localStorage.getItem('drugNamePath')==='elitek' ) {
        //      return this.layout.configuration.images.headerElitek || this.$settings.url(this.$settings.headerLogoElitek);
        // }else if(localStorage.getItem('drugNamePath')==='jevtana') {
        //     return this.layout.configuration.images.headerJevtana || this.$settings.url(this.$settings.headerLogoJevtana);
        // }
         else if(localStorage.getItem('drugNamePath')==='sarclisa') {
            if(localStorage.getItem('enrollmentTypePatientOrHCP')==='HCP'){
                return this.layout.configuration.images.headerSarclisa || this.$settings.url(this.$settings.headerLogoSarclisaHCP);
            }
            else{
                return this.layout.configuration.images.headerSarclisa || this.$settings.url(this.$settings.headerLogoSarclisaPatient);
            }
            }
        else{
           // return this.layout.configuration.images.header || this.$settings.url(this.$settings.headerLogo);
            if(localStorage.getItem('enrollmentTypePatientOrHCP')==='HCP'){
                return this.layout.configuration.images.headerSarclisa || this.$settings.url(this.$settings.headerLogoSarclisaHCP);
            }
            else{
                return this.layout.configuration.images.headerSarclisa || this.$settings.url(this.$settings.headerLogoSarclisaPatient);
            }
        }
        }


    public setHeaderStyle() {
        if(this.$route.name ==='index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement' ){
            if(this.$vuetify.breakpoint.width<387) {
                return {
                    width:"190px",
                    height:"95%",
                    marginTop:"0",
                }
            }
            if(this.$vuetify.breakpoint.width<438) {
                return {
                    width:"200px",
                    height:"86%",
                    marginTop:"0",
                }
            }
            if(this.$vuetify.breakpoint.width<780) {
                return {
                    width:"250",
                    height:"93%",
                    marginTop:"0",
                }
            }
            if(this.$vuetify.breakpoint.width<1036){
                return {
                    width:"290",
                    height:"98%",
                    marginTop:"0",
                }
            }
            return {
                width:"255px",
                height:"90%",
                marginTop:"0",
            }
        }
        // if(localStorage.getItem('drugNamePath')==='elitek') {
        //     if(this.$vuetify.breakpoint.width<387) {
        //         return {
        //             width:"180px",
        //             height:"100%",
        //             marginTop:"0",
        //             position:"relative",
        //             left:"0px",
        //             top:"-5px"
        //         }
        //     }
        //     if(this.$vuetify.breakpoint.width<438) {
        //         return {
        //             width:"220px",
        //             height:"100%",
        //             marginTop:"0",
        //             position:"relative",
        //             left:"0px",
        //             top:"-5px"
        //         }
        //     }
        //     if(this.$vuetify.breakpoint.width<780) {
        //         return {
        //             width:"250px",
        //             height:"100%",
        //             marginTop:"0",
        //             position:"relative",
        //             left:"-9px",
        //             top:"-10px"
        //         }
        //     }
        //     if(this.$vuetify.breakpoint.width<1036){
        //         return {
        //             width:"300px",
        //             height:"100%",
        //             marginTop:"0",
        //         }
        //     }
        //     return {
        //         width:"370px",
        //         height:"100%",
        //         marginTop:"0",
        //         position:"relative",
        //         left:"-9px",
        //         top:"-10px"
        //     }
        // }
        // else if(localStorage.getItem('drugNamePath')==='jevtana') {
        //     if(this.$vuetify.breakpoint.width<387) {
        //         return {
        //             width:"180px",
        //             height:"100%",
        //             position:"relative",
        //             left:"0px",
        //             top:"-10px"
        //         }
        //     }
        //     if(this.$vuetify.breakpoint.width<438) {
        //         return {
        //             width:"220px",
        //             height:"100%",
        //             position:"relative",
        //             left:"0px",
        //             top:"-10px"
        //         }
        //     }
        //     if(this.$vuetify.breakpoint.width<780) {
        //         return {
        //             width:"270px",
        //             height:"100%",
        //             marginBottom: "10px",
        //             marginTop:"0px",
        //             position:"relative",
        //             left:"-9px",
        //             top:"-10px"
        //         }
        //     }
        //     if(this.$vuetify.breakpoint.width<1036) {
        //         return {
        //             width:"320px",
        //             height:"100%",
        //             position:"relative",
        //             left:"-9px",
        //             top:"-15px"
        //         }
        //     }
        //     return {
        //             width:"370px",
        //             height:"100%",
        //             marginTop:"1px",
        //             position:"relative",
        //             left:"-9px",
        //             top:"-10px"
        //     }
        // }
        else {
            if(this.$vuetify.breakpoint.width<387) {
                return {
                    width:"160px",
                    height:"100%",
                    position:"relative",
                    top:"-10px",
                }
            }
            if(this.$vuetify.breakpoint.width<438) {
                return {
                    width:"200px",
                    height:"100%",
                    position:"relative",
                    top:"-15px",
                    left:"5px"
                }
            }
            if(this.$vuetify.breakpoint.width<780) {
                return {
                    width:"250px",
                    height:"100%",
                    position:"relative",
                    top:"-20px"
                }
            }
            if(this.$vuetify.breakpoint.width<1036){
                return {
                    width:"300px",
                    height:"100%",
                    marginTop:"5px",
                }
            }
            return {
                width:"350px",
                height:"100%",
                position:"relative",
                top:"-30px"
            }
        }
        // else{
        //     if(this.$vuetify.breakpoint.width<387) {
        //                     return {
        //                         width:"160px",
        //                         height:"100%",
        //                         marginTop:"0",
        //                     }
        //                 }
        //                 if(this.$vuetify.breakpoint.width<438) {
        //                     return {
        //                         width:"200px",
        //                         height:"100%",
        //                         marginTop:"0",
        //                     }
        //                 }
        //                 if(this.$vuetify.breakpoint.width<780) {
        //                     return {
        //                         width:"250px",
        //                         height:"100%",
        //                         marginTop:"0",
        //                     }
        //                 }
        //                 if(this.$vuetify.breakpoint.width<1036){
        //                     return {
        //                         width:"300px",
        //                         height:"100%",
        //                         marginTop:"0",
        //                     }
        //                 }
        //                 return {
        //                     width:"255px",
        //                     height:"100%",
        //                     marginTop:"0",
        //                 }
        // }
    }

    public setHeaderLogoDataTest(){
        if(this.$route.name ==='index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement' ){
            return "img_header_logo"
        }
        else{
            if(localStorage.getItem('drugNamePath')==='elitek') {
                return "elitek_img_header_logo"
            }
            else if(localStorage.getItem('drugNamePath')==='jevtana') {
                return "jevtana_img_header_logo"
            }
            else{
                return "sarclisa_img_header_logo"
            }
        }
    }

    public get isAbsolute() {
        return this.layout.configuration.logoPosition !== 'start';
    }

    public get isScrolling() {
        return this.layout.configuration.headerStyle === 'scrolling';
    }
    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }

    handleClick() {
        this.$vuetify.goTo('#main-footer', {
            duration: 1000,
            easing: 'easeInOutCubic',
            offset: 70,
        });
    }
    logoClick() {
        // Clearstore after delay of 200ms to avoid conflict with any pages' beforeDestroy logic.
        let obj = this;
        setTimeout(() => {
            obj.enrollment.clearStore();
            this.uploadModule.clearStore();
            this.uploadModule.setIsFreshStart(true);
        }, 70);
    }
}
